import AllergiesForm from './allergies'
import CardiovascularForm from './cardiovascular'
import DigestiveForm from './digestive'
import EndocrineForm from './endocrine'
import EnteForm from './ente'
import GeneralForm from './general'
import GenitourinaryForm from './genitourinary'
import HematologicForm from './hematologic'
import IntegumentaryForm from './integumentary'
import MentalHealthForm from './mentalHealth'
import MusculoskeletalForm from './musculoskeletal'
import NeurologicalForm from './neurological'
import RespiratoryForm from './respiratory'

export { GeneralForm }
export { EnteForm }
export { RespiratoryForm }
export { CardiovascularForm }
export { DigestiveForm }
export { GenitourinaryForm }
export { MusculoskeletalForm }
export { NeurologicalForm }
export { IntegumentaryForm }
export { MentalHealthForm }
export { EndocrineForm }
export { HematologicForm }
export { AllergiesForm }

export default {
  GeneralForm,
  EnteForm,
  RespiratoryForm,
  CardiovascularForm,
  DigestiveForm,
  GenitourinaryForm,
  MusculoskeletalForm,
  NeurologicalForm,
  IntegumentaryForm,
  MentalHealthForm,
  EndocrineForm,
  HematologicForm,
  AllergiesForm
}
